module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.eot
// module id = 356
// module chunks = 3